 
<template>
	<div class="personal clearfix fr">
		<!-- 登录之后-个人中心 -->
		<div class="txt-login fl clearfix" v-show="isLogin">
			<div class="el-dropdown-link fl">
				<p class="username">
					<i class="iconfont icon-yonghu"></i>欢迎！
					{{username}}
				</p>
			</div>
		</div>
		<!-- 未登录 -->
		<div class="txt-login fl clearfix" v-show="!isLogin">
			<!-- <el-button type="primary" class="fl" @click="dialogVisibleLogin=true;">登录</el-button> -->
			<el-button type="primary" class="fl" @click="toLoginPage">登录</el-button>
		</div>
		<!-- 登录弹窗 -->
		<el-dialog
			:visible.sync="dialogVisibleLogin"
			width="300px"
			class="dialogVisibleLogin"
			append-to-body
			:modal-append-to-body="false"
			:close-on-click-modal="false"
		>
			<div class="login-r-con">
				<div class="login-r-con-inner">
					<h2 class="title">登录</h2>
					<div class="login_inputbox">
						<i class="iconfont icon-touxiang"></i>
						<input
							class="login_input"
							name="Account"
							placeholder="用户名"
							autofocus="autofocus"
							v-model="username"
						/>
					</div>
					<div class="login_inputbox">
						<i class="iconfont icon-icon2"></i>
						<input
							type="password"
							name="Password"
							class="login_input"
							placeholder="密 码"
							v-model="password"
							@keyup.enter="loginFun"
						/>
					</div>
					<!-- <div class="freelogin" @click="freeLogin">免登录</div> -->
					<a class="loginBtn" @click="loginFun">登录</a>
				</div>
			</div>
		</el-dialog>
	</div>
</template>
<script>

export default {
	data() {
		return {
			username:"",//用户名
			groupid_list: [],
			password: "", //密码
			userid: "",
			isLogin: false, //默认没有登录
			dialogVisibleLogin: false, //登录弹窗默认不显示
			//can_check_files:"",//是否有立法知识库的权限 "yes"有 "no"没有
		};
	},
	created() {
		//防止登录之后通过网址栏中的箭头返回到登录页 要清空loacalStorage中的数据！！！
		// window.localStorage.clear();
		this.username = window.localStorage.getItem("username");
		// this.groupid_list = JSON.parse(
		// 	window.localStorage.getItem("groupid_list")
		// );
		if (this.username) {
			this.isLogin = true;
		}
		//是否有立法知识库的权限
		//this.can_check_files = window.localStorage.getItem("can_check_files");
	},
	methods: {
		toLoginPage(){
			this.$router.push({
				path: '/login',
          	})
		},

		//登录功能
		loginFun() {
			// console.log(window.cookie)
			if (!this.username) {
				this.$message({
					message: "用户名不能为空！",
					type: "warning",
					duration: 3000
				});
				return false;
			}
			if (!this.password) {
				this.$message({
					message: "密码不能为空！",
					type: "warning",
					duration: 3000
				});
				return false;
			}
			this.axios
				.get("/api/user/login/normal/?username="+this.username+"&password="+this.password)
				.then(res => {
					if (res.data.code == 200) {
						console.log("登录成功======");
						console.log(res);
						//判断浏览器是否支持 localStorage 这个属性
						if (!window.localStorage) {
							alert("您的浏览器不支持localstorage");
							return false;
						} else {
							// 将用户名存储到window.localStorage
							window.localStorage.setItem(
								"username",
								res.data.data.username
							);
							window.localStorage.setItem(
								"token",
								res.data.data.token
							);							
							this.dialogVisibleLogin = false; //弹窗消失
							this.isLogin = true; //登录 个人中心显示

							this.axios({
								method:"get",
								url:"/japi/user/is_has_permission/",
								params:{
									perm_codename_list:JSON.stringify(['can_check_files'])
								}
							 }).then(res => {
								console.log("权限返回======");
								console.log(res);
								if (res.data.code == 200 || res.data.code == 403) {
									console.log("权限返回成功======");
									//判断浏览器是否支持 localStorage 这个属性
									if (!window.localStorage) {
										alert("您的浏览器不支持localstorage");
										return false;
									} else {
										//存储到window.localStorage
										window.localStorage.setItem(
											"can_check_files",
											res.data.data[0].can_check_files
										);
										//跳转页面刷新
										this.$router.push("/refresh");
									}
								}else{
									// 存储到window.localStorage "no"
									window.localStorage.setItem(
										"can_check_files",
										res.data.data[0].can_check_files
									);
									//跳转页面刷新
									this.$router.push("/refresh");
									// this.$message({
									// 	message: res.data.msg,
									// 	type: "warning",
									// 	duration: 3000
									// });
								} 
							}); 
						}
					} else{
						this.$message({
							message: res.data.msg,
							type: "warning",
							duration: 3000
						});
					} 
				});
		},
	}
};
</script>
<style lang="scss">
@import "../../assets/css/mixin.scss"; //定义方法
//登录弹窗样式
.login-r-con {
	position: relative;
	z-index: 2;
	width: 300px;
	height: 300px;
	margin: 0 auto;
	.login-r-con-inner {
		width: 300px;
		margin: 0 auto;
	}
	.freelogin {
		text-align: right;
		color: $loginInputIconColor;
		font-size: 12px;
		margin-top: 30px;
		cursor: pointer;
		width: 80%;
		margin: 0 auto;
		line-height: 22px;
	}
	a.loginBtn {
		text-align: center;
		margin-top: 10px;
		height: 42px;
		line-height: 42px;
		@include theme();
		font-size: 16px;
		color: #fff;
		border-radius: 4px;
		display: block;
		width: 80%;
		margin: 0 auto;
	}
	.title {
		font-size: 22px;
		line-height: 40px;
		text-align: center;
		color: #333;
		padding-top: 5px;
		letter-spacing: 1px;
		padding-bottom: 0;
	}
	.tips_box {
		padding-left: 10px;
		font-size: 12px;
		color: #f70;
		width: 290px;
		margin: 0px auto 10px;
		line-height: 24px;
		background: #fdf6ec;
		border: 1px solid #f70;
	}
	.login_inputbox {
		width: 74%;
		padding-left: 16px;
		margin: 20px auto;
		@include themeBorderColor(1px,solid);
		border-radius: 4px;
		line-height: 42px;
		background: transparent;
		i {
			font-size: 20px;
			@include themeFontColor();
		}
	}
	.login_input {
		height: 42px;
		width: 80%;
		font-size: 14px;
		line-height: 42px;
		border: none;
		padding-left: 12px;
		outline: none;
		color:#333;
		background: transparent;
	}
	input::-webkit-input-placeholder {
		// @include themeFontColor();
		color:#333;
	}
	input::-moz-placeholder {
		/* Mozilla Firefox 19+ */
		// @include themeFontColor();
		color:#333;
	}
	input:-moz-placeholder {
		/* Mozilla Firefox 4 to 18 */
		// @include themeFontColor();
		color:#333;
	}
	input:-ms-input-placeholder {
		/* Internet Explorer 10-11 */
		// @include themeFontColor();
		color:#333;
	}
}
.dialogVisibleLogin {
	.el-dialog__body {
		padding: 7px 0 0;
	}
	.el-dialog {
		margin-top: 23vh !important;
		background:$loginShowBg;
	}
	.el-form-item__label {
		width: 90px !important;
	}
	.el-form-item__content {
		margin-left: 90px !important;
		.el-input {
			width: 88%;
		}
	}
	.el-input__inner {
		border: solid 1px #1489cc;
		background: transparent;
	}
	.demo-ruleForm {
		padding-top: 12px;
	}
	.el-form-item {
		margin-bottom: 20px;
	}
	.el-dialog__headerbtn .el-dialog__close{
		font-size: 22px;
		color:#666;
	}
	.el-dialog__headerbtn:focus .el-dialog__close, .el-dialog__headerbtn:hover .el-dialog__close{
		@include themeFontColor();
	}
}
// 个人中心样式
.personal {
	// background: blue;
	font-size: 13px;
	color: #fff;
	line-height: 30px;
	margin-right: 20px;
	margin-top: 28px;
	.txt-login {
		// cursor: pointer;
		.username {
			color: #fff;
			height: 30px;
			padding-left: 37px;
			@include fontSize($fz14, $num);
			// background: url('../../assets/images/login-header.png') 0 center no-repeat;
			i{
				margin-right:10px;
				font-size: 24px;
			}
			margin-right: 28px;
			// i{
			// 	border:1px solid #fff;
			// 	padding:4px;
			// 	border-radius:50%;
			// 	margin-right: 3px;
			// }
		}
	}
	.el-button--primary {
		background-color:transparent;
		border-radius: 30px;
		border-color: #fff;
	}
	.el-button--primary:focus, .el-button--primary:hover {
		background:transparent;
		// color:#fff;
		border-color:#fff;
		text-decoration: underline;
	}
	.el-button {
		padding: 7px 15px;
	}
	.help {
		color: #fff;
		margin-left: 12px;
		&:before {
			width: 1px;
			height: 18px;
			margin-right: 12px;
			content: "|";
			color: #75a6de;
		}
	}
}
</style>

